<template>
  <div>
    <SubHeader title="History" />

    <b-row class="my-1">
      <b-col md="3">
        <label for="selectedViewType">View Notes</label>
      </b-col>
      <b-col md="6">
        <b-form-select
          id="selectedViewType"
          v-model="selectedViewType"
          :options="viewTypes"
        ></b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
        <label for="selectedCategory">Category</label>
      </b-col>
      <b-col md="6">
        <b-form-select
          id="selectedCategory"
          v-model="selectedCategory"
          :options="categories"
        ></b-form-select>
      </b-col>
    </b-row>

    <b-row class="my-1">
      <b-col md="3">
        <label for="selectedSystem">System</label>
      </b-col>
      <b-col md="6">
        <b-form-select
          id="selectedSystem"
          v-model="selectedSystem"
          :options="systemTypes"
        ></b-form-select>
      </b-col>
    </b-row>


    <b-table :items="historyItems" :fields="fields" class="table" :responsive="true">
      <template v-slot:cell(history)="data" >
        <div v-if="data.item.companyVendor">
          {{ data.item.companyVendor.fullname || `${data.item.companyVendor.title} ${data.item.companyVendor.firstName} ${data.item.companyVendor.lastName}`}}
        </div>
        <span v-bind:class="{ red: data.item.isStatusChange == true }">{{data.item.notes}}</span>
      </template>

      <template v-slot:cell(user)="data" :class="{ red: data.item.isStatusChange }">
        <span v-bind:class="{ red: data.item.isStatusChange == true }">{{data.item.createdFullname}}</span>
      </template>

      <template v-slot:cell(date)="data" :class="{ red: data.item.isStatusChange }">
        <span v-bind:class="{ red: data.item.isStatusChange == true }">{{getDate(data.item.createdDatetime)}}</span>
      </template>
    </b-table>
  </div>
</template>


<script>
import SubHeader from "@/components/shared/SubHeader.vue";
import { format } from 'date-fns'

export default {
  components: { SubHeader },
  props: {
    history: Array
  },
  data() {
    return {
      loadedCompany: this.company,
      viewTypes: [
        {text: "Company History", value: 1},
        {text: "Field Changes", value: 2},
        {text: "Suppression Field Changes", value: 3},
      ],
      systemTypes: [
        {text: "One80", value: 2},
        {text: "Globe", value: 1},
        {text: "RandD", value: 3},
        { text: "Pinnacle", value: 4 },
      ],
      selectedViewType: 1,
      selectedCategory: "All History",
      selectedSystem: 3,
      fields: [
        { key: "history", label: "History", sortable: false },
        { key: "user", label: "User", sortable: false },
        { key: "date", label: "Date", sortable: false },
      ]
    };
  },
  computed: {
    categories: function() {

      var categories = []

      if (this.company && this.history.length > 0) {
        categories = [...new Set(this.history.map(item => item.history))]
      }
      categories = categories.sort()

      return ["All History"].concat(categories)
    },
    historyItems: function() {
      if (!this.history) return []

      if (this.selectedViewType == 1) {
        if (this.selectedCategory == "All History") {
          return this.history.filter(x => x.isSuppressionChange == false && x.systemId == this.selectedSystem && x.isFieldChange == false)
        }
        return this.history.filter(x => x.isSuppressionChange == false && x.history == this.selectedCategory && x.systemId == this.selectedSystem && x.isFieldChange == false)
      }

      if (this.selectedViewType == 2) {
        return this.history.filter(x => x.isFieldChange == true && x.systemId == this.selectedSystem)
      }

      if (this.selectedViewType == 3) {
        return this.history.filter(x => x.isSuppressionChange == true && x.systemId == this.selectedSystem)
      }

      return this.history
    }
  },
  methods: {
    getDate(date) {
      return format(new Date(date), "dd/MM/yyyy HH:mm")
    },
  },
};
</script>


<style scoped>
  .table {
    font-size: 0.85em;
  }
</style>
